import { useApp } from '../../context/AppContext';
import './Pages.css';

const FAQ = () => {
  const { setCurrentView } = useApp();

  const faqs = [
    {
      question: 'Is GoSplitPDF free to use?',
      answer: 'Yes, GoSplitPDF is completely free to use. There are no hidden fees, subscriptions, or limitations on the number of files you can process.'
    },
    {
      question: 'Are my files secure?',
      answer: 'Absolutely. Most PDF processing happens directly in your browser - your files never leave your device. For features that require server processing (like Word/Excel/PowerPoint conversion), files are encrypted during transfer and automatically deleted immediately after conversion.'
    },
    {
      question: 'What file types can I convert to PDF?',
      answer: 'You can convert images (JPG, PNG, GIF, WebP), HTML files, and Microsoft Office documents (Word, Excel, PowerPoint) to PDF format.'
    },
    {
      question: 'Is there a file size limit?',
      answer: 'The default limit is 10MB per file, which works well for most documents. This can be adjusted in the Settings if needed.'
    },
    {
      question: 'Can I merge multiple PDFs?',
      answer: 'Yes, you can combine multiple PDF files into a single document using our Merge feature. Simply upload the files and arrange them in your preferred order.'
    },
    {
      question: 'How do I add a signature to a PDF?',
      answer: 'Upload your PDF, then select the Sign feature. You can draw your signature using your mouse or touchscreen, or upload an image of your signature. Position it anywhere on any page of your document.'
    },
    {
      question: 'Can I split a PDF into multiple files?',
      answer: 'Yes, you can extract specific pages or split a PDF into multiple documents. Upload your PDF and use the Split feature to select which pages to extract.'
    },
    {
      question: 'What browsers are supported?',
      answer: 'GoSplitPDF works on all modern browsers including Chrome, Firefox, Safari, and Edge. We recommend using the latest version for the best experience.'
    },
    {
      question: 'Do I need to create an account?',
      answer: 'No account is required. You can start using all features immediately without signing up or logging in.'
    },
    {
      question: 'What is the Redact feature?',
      answer: 'The Redact feature allows you to permanently black out sensitive information in your PDFs. This is useful for hiding personal data, confidential information, or any content you want to remove before sharing.'
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <button className="btn btn-ghost" onClick={() => setCurrentView('upload')}>
          ← Back to Home
        </button>
        <h1>Frequently Asked Questions</h1>
      </div>

      <div className="page-content">
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3 className="faq-question">{faq.question}</h3>
              <p className="faq-answer">{faq.answer}</p>
            </div>
          ))}
        </div>

        <div className="page-cta">
          <p>Still have questions?</p>
          <button className="btn btn-primary" onClick={() => setCurrentView('contact')}>
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
